module.exports = __webpack_public_path__ + "img/ghost.d5d51e42.svg";